import React from "react";

import { Button, Form, Input } from "antd";
import { useTranslation } from "react-i18next";

import { phoneNumberRegExp } from "../../../../utils/regExps";
import { ContactFormInputModel, ContactFormProps } from "./types";

function ContactForm({ onSendApplication, isDataLoading }: ContactFormProps) {
  const { t } = useTranslation("translations");
  const [form] = Form.useForm<ContactFormInputModel>();

  return (
    <Form<ContactFormInputModel> layout="vertical" onFinish={onSendApplication} form={form}>
      <Form.Item name="fullname" label={t("fullname")} rules={[{ required: true, message: t("enter_fullname") }]}>
        <Input placeholder={t("fullname")} />
      </Form.Item>

      <Form.Item
        name="phoneNumber"
        label={t("phone_number")}
        rules={[
          {
            validator: async (_, value?: string) => {
              if (!value) {
                throw new Error(t("enter_phone_number"));
              }
              if (!phoneNumberRegExp.test(value)) {
                throw new Error(t("enter_phone_number_in_format"));
              }
            },
          },
        ]}
      >
        <Input placeholder={t("phone_number")} />
      </Form.Item>

      <Form.Item
        name="email"
        label="Email"
        rules={[
          { required: true, message: t("enter_email") },
          { type: "email", message: t("wrong_email") },
        ]}
      >
        <Input placeholder="Email" />
      </Form.Item>

      <Form.Item name="message" label={t("message")} rules={[{ required: true, message: t("enter_message") }]}>
        <Input.TextArea placeholder={t("message")} maxLength={300} showCount autoSize />
      </Form.Item>

      <Button type="primary" htmlType="submit" block loading={isDataLoading}>
        {t("send")}
      </Button>
    </Form>
  );
}

export default React.memo(ContactForm);
